<div class="flex flex-col md:flex-row items-center print:flex-row flex-wrap {{ extraClass }}">
  @if (title) {
    <div
      class="flex-1 flex flex-row items-center w-full"
      [ngClass]="{ 'mb-lg md:mb-0': contentSlot.children.length && !forOverview }"
    >
      <div class="flex-1 flex flex-col md:pr-base">
        <div class="flex flex-row items-center">
          <div class="text-lg leading-lg font-semibold text-txt capitalize">{{ title }}</div>
          <ng-content select="[slot=titleExtra]"></ng-content>
        </div>
        <div #subTitleSlot [ngClass]="{ subtitle: subTitleSlot.children.length }">
          <ng-content select="[slot=subTitle]"></ng-content>
        </div>
        @if (!subTitleSlot.children.length && subTitle) {
          <div class="subtitle">
            {{ subTitle }}
          </div>
        }
      </div>
      <ng-content select="[slot=titleAction]"></ng-content>
    </div>
  }

  <div class="w-full md:w-auto" [ngClass]="{ 'w-auto!': forOverview }" #contentSlot>
    <ng-content></ng-content>
  </div>
</div>
